import React, { Component } from 'react';
import CategorieRicambioService from '../../services/api/categorie-ricambio.service';
import ModalForm from '../../common/ModalForm';
import Table from '../../common/TableComponent';
import getListPartCategorieColumnDefs, { listPartCategoriesColumns } from '../../config/table-columns/categorie-ricambio';
import { addPartCategoryFormFields, editPartCategoryFormFields } from '../../config/form-fields/categorie-ricambio';
import { IPartCategory, IPartCategoryRow } from '../../helpers/interfaces/categories';
import { IRole, ILoggedUser } from '../../helpers/interfaces/user';
import { IFormField } from "../../helpers/interfaces/generic";
import * as Yup from "yup";
import Swal from "sweetalert2";
import EventBus from '../../common/EventBus';

const $ = require('jquery');

type State = {
    formFields: Array<IFormField>,
    formInitialValues: { [key: string]: any },
    showModal: boolean,
    modalType: string,
    modalTitle: string,
    categoriesList: IPartCategoryRow[],
    categoriesNumber: number,
    hasPermissions: boolean
}

export default class CategorieRicambio extends Component<{}, State> {

    apiSubmit: any;

    constructor(props: {}) {
        super(props)

        this.state = {
            formFields: [],
            formInitialValues: {},
            showModal: false,
            modalType: '',
            modalTitle: '',
            categoriesList: [],
            categoriesNumber: 0,
            hasPermissions: false
        }
    }

    async componentDidMount() {
        EventBus.dispatch("showLoader", { text: 'Caricamento dati in corso...' });

        const userString: any = localStorage.getItem("user");
        const currentUser: ILoggedUser = JSON.parse(userString);
        currentUser.roles.map((role: IRole) => {
            // if (role.code.toLocaleLowerCase() === "adm") this.setState({hasPermissions: true});
            this.setState({hasPermissions: true});
            return null;
        });

        CategorieRicambioService.getPartCategories()
        .then((response: IPartCategory) => {
            this.setState({ categoriesList: response.rows, categoriesNumber: response.total_rows });
        })
        .catch(() => {
            Swal.fire({
                title: 'Si è verificato un errore',
                text: 'Non è stato possibile recuperare i dati.',
                icon: 'error',
            });
        })
        .finally(() => {
            EventBus.dispatch("hideLoader");
        });

        $('#table_part-categories').on('click', '.edit_btn', async (e: any) => {
            e.preventDefault();
            EventBus.dispatch("showLoader", { text: 'Caricamento dati in corso...' });

            const categoriaId = $(e.currentTarget).data('id');
            const categoriaDettagli = await CategorieRicambioService.getPartCategory(categoriaId);

            if (categoriaDettagli) {
                this.setState({
                    formFields: editPartCategoryFormFields(),
                    formInitialValues: {...categoriaDettagli}
                }, () => {
                    this.apiSubmit = CategorieRicambioService.editPartCategory;
                    this.setState({ showModal: true, modalType: 'edit', modalTitle: 'Modifica i dettagli della categoria' });
                });
            }
            EventBus.dispatch("hideLoader");
        });

        $('#table_part-categories').on('click', '.delete_btn', async (e: any) => {
            e.preventDefault();
            Swal.fire({
                title: 'Confermi l\'eliminazione?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Conferma',
                cancelButtonText: 'Annulla'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const idItem = $(e.currentTarget).data('id');
                    const response: any = await CategorieRicambioService.deletePartCategory(idItem);
                    if (response && typeof response.error !== 'undefined') {
                        Swal.fire(
                            response.error,
                            '',
                            'error'
                        );
                    } else {
                        window.location.reload();
                    }
                }
            });
        });
    }

    async openAddModale() {
        this.setState({
            formFields: addPartCategoryFormFields(),
            formInitialValues: {}
        }, () => {
            this.apiSubmit = CategorieRicambioService.addPartCategory;
            this.setState({ showModal: true, modalType: 'add', modalTitle: 'Aggiungi una nuova categoria' });
        });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    validationSchema() {
        let validations: any = {};
        this.state.formFields.forEach((value: any, key: any) => (validations[value.name] = value.validation));

        return Yup.object().shape(validations);
    }

    render() {
        const { formFields, formInitialValues, showModal, modalTitle, modalType, categoriesList, hasPermissions } = this.state;

        // const buttons = ['excel', 'pdf', 'print']
        return (
            <React.Fragment>
                <div className='custom-container'>
                    <div className="card">
                        <div className="card-body">
                            <div className="form-group mb-3 d-flex justify-content-between align-items-center">
                                <h2 className="card-title">Categorie ricambio</h2>
                                {
                                    hasPermissions &&
                                    <button id="add_btn" type="button" className="btn topic-empty-btn-color" onClick={() => this.openAddModale()}>
                                        <span>Aggiungi categoria</span>
                                    </button>
                                }
                            </div>
                            <ModalForm
                                showModal={showModal}
                                modalTitle={modalTitle}
                                modalType={modalType}
                                formFields={formFields}
                                initialValues={formInitialValues}
                                apiSubmit={this.apiSubmit}
                                closeCallback={this.closeModal.bind(this)}
                            />
                            {
                                // categoriesList.length > 0 &&
                                <Table id={'table_part-categories'} columns={listPartCategoriesColumns} columnDefs={getListPartCategorieColumnDefs()} datas={categoriesList} buttons={[]} />
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
